import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountIdentity, IAMAccountRawPassword } from "../interface";
import { iamAccountIdentity, iamAccountRawPassword } from "../schema";

export class IAMAccountSignInCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountSignInCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountSignInCmdRaw) {
    JsonSchemaValidator.assert(IAMAccountSignInCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["identity", "password"],
      properties: {
        identity: iamAccountIdentity,
        password: iamAccountRawPassword
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountSignInCmdRaw {
  identity: IAMAccountIdentity;
  password: IAMAccountRawPassword;
}
